import { render, staticRenderFns } from "./ProfileComments.vue?vue&type=template&id=c614b9ca&scoped=true"
import script from "./ProfileComments.vue?vue&type=script&lang=js"
export * from "./ProfileComments.vue?vue&type=script&lang=js"
import style0 from "./ProfileComments.vue?vue&type=style&index=0&id=c614b9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c614b9ca",
  null
  
)

export default component.exports